import i18n from "@/i18n";
import { LocaleMessage } from "vue-i18n";

export default class OrderStatusOptions {
  public static get statusOptions(): StatusOptions[] {
    return [
      {
        // text: i18n.t('filters.orderStatusFilter.active'),
        text: 'Active',
        value: 'active',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.inactive'),
        text: 'Inactive',
        value: 'inactive',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.preview'),
        text: 'Preview',
        value: 'preview',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.finalized'),
        text: 'Finalized',
        value: 'finalized',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.checkout'),
        text: 'Checkout',
        value: 'checkout',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.invoiced'),
        text: 'Invoiced',
        value: 'invoiced',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.completed'),
        text: 'Completed',
        value: 'completed',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.lost'),
        text: 'Lost',
        value: 'lost',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.cancelled'),
        text: 'Cancelled',
        value: 'cancelled',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.allocated'),
        text: 'Allocated',
        value: 'allocated',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.partiallyAllocated'),
        text: 'Partially Allocated',
        value: 'partially_allocated',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.picked'),
        text: 'Picked',
        value: 'picked',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.partiallyPicked'),
        text: 'Partially Picked',
        value: 'partially_picked',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.shipped'),
        text: 'Shipped',
        value: 'shipped',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.partiallyShipped'),
        text: 'Partially Shipped',
        value: 'partially_shipped',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.dispatched'),
        text: 'Dispatched',
        value: 'dispatched',
        type: 'status',
      },
      {
        // text: i18n.t('filters.orderStatusFilter.partiallyDispatched'),
        text: 'Partially Dispatched',
        value: 'partially_dispatched',
        type: 'status',
      },
    ];
  }
}

export interface StatusOptions {
  text?: string | LocaleMessage;
  value?: string;
  type?: string;
}

